exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.app-main[data-v-078753dd] {\r\n  /*50 = navbar  */\r\n  min-height: calc(100vh - 50px);\r\n  width: 100%;\r\n  position: relative;\r\n  overflow: hidden;\r\n  /* background: #f8f9fc; */\n}\n.fixed-header + .app-main[data-v-078753dd] {\r\n  padding-top: 50px;\n}\r\n", ""]);

// exports
